import { render, staticRenderFns } from "./dietPlanTemplate.vue?vue&type=template&id=bce2cf8e&scoped=true&"
import script from "./dietPlanTemplate.vue?vue&type=script&lang=js&"
export * from "./dietPlanTemplate.vue?vue&type=script&lang=js&"
import style0 from "./dietPlanTemplate.vue?vue&type=style&index=0&id=bce2cf8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce2cf8e",
  null
  
)

component.options.__file = "dietPlanTemplate.vue"
export default component.exports